<template>
    <div id="app">
        <component :is="layout">
            <router-view />
        </component>
    </div>
</template>

<script>
const defaultLayout = 'default';

export default {
    computed: {
        layout() {
            return `${this.$route.meta.layout || defaultLayout}-layout`;
        },
    },
};
</script>

<style>
#app {
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}
</style>
